var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThjnk = function SvgThjnk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 656.10669 417.06668",
    height: 417.06668,
    width: 656.10669,
    xmlSpace: "preserve",
    id: "svg2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,417.06667)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 2361.98,1829.9 c -93.05,0 -137.29,48.8 -137.29,135.76 0,88.47 44.24,134.24 137.29,134.24 93.05,0 135.77,-45.77 135.77,-134.24 0,-86.96 -42.72,-135.76 -135.77,-135.76 m -1318.9,-59.19 h 64 v 212.95 l 251.69,102.5 v -315.45 h 133.82 v -205.93 h -133.82 v -241.02 c 0,-48.83 18.31,-67.13 65.6,-67.13 h 68.65 v -213.55 h -135.76 c -180.01,0 -250.18,82.36 -250.18,251.7 v 270 h -64 z m 2834.65,-727.63 h -279.16 l -76.27,230.34 -44.23,-62.55 v -167.79 h -250.18 v 779.37 c -4.47,35.18 -23.62,48.95 -64.46,48.95 h -2.33 v 213.56 h 319.62 V 1584.7 l 105.66,186.01 h 285.26 L 3696.2,1520.54 Z m -1323.81,0 v 727.64 h 221.18 v -83.91 c 35.09,64.07 96.1,102.21 189.16,102.21 125.09,0 196.78,-70.17 196.78,-225.77 v -520.17 h -251.7 v 474.41 c 0,47.28 -16.78,62.54 -48.82,62.54 -33.56,0 -54.91,-19.83 -54.91,-70.17 v -466.78 z m -994.05,0 v 1041.87 h 251.7 v -355.43 c 36.61,38.14 88.47,61.02 158.64,61.02 126.62,0 198.31,-71.69 198.31,-227.29 v -520.17 h -251.7 v 475.93 c 0,45.76 -18.3,61.02 -48.82,61.02 -33.55,0 -56.43,-19.83 -56.43,-70.17 v -466.78 z m 608.65,-44.24 V 776.121 h 45.47 c 181.54,0 273.06,68.649 273.06,257.799 v 736.79 h -251.69 v -729.15 c 0,-32.05 -13.73,-42.72 -41.19,-42.72 h -25.65"
  }))));
};
export default SvgThjnk;